import { createAction } from "redux-act";

export const checkDomain = createAction("submit dispute modal data");

export const setDomainValid = createAction<boolean>(
  "set domain valid or invalid"
);
